import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppShell from '../components/AppShell';
import Toast from '../components/Toast';

/**
 * Preferences page — Notifications + Support & legal, merged per user feedback.
 * All rows are currently STUBBED as "coming soon" — Phase 4 will wire real prefs.
 */
export default function PreferencesPage() {
  const navigate = useNavigate();
  const [toast, setToast] = useState(null);
  const soon = (label) => setToast({ msg: `🚧 ${label} — coming soon.` });

  const notifRows = [
    { key: 'push', label: 'Push notifications', desc: 'Trades, mentions, and Clan drops' },
    { key: 'digest', label: 'Email digest', desc: 'Weekly summary of your Clans' },
    { key: 'live', label: 'Live streams', desc: 'When creators you follow go live' },
  ];
  const supportRows = ['Help center', 'Terms of service', 'Privacy policy'];

  return (
    <AppShell activeTab="wallet">
      <div className="settings-wrap" data-testid="preferences-page">
        <h1 className="settings-title">Preferences</h1>

        <div className="group-label">Notifications</div>
        <div className="settings-card">
          {notifRows.map((n) => (
            <div
              className="settings-row"
              key={n.key}
              onClick={() => soon(n.label)}
              role="button"
              tabIndex={0}
              data-testid={`pref-notif-${n.key}`}
            >
              <div className="row-info">
                <div className="row-label">{n.label}</div>
                <div className="row-value">{n.desc}</div>
              </div>
              <span className="soon-pill">Soon</span>
            </div>
          ))}
        </div>

        <div className="group-label">Support &amp; legal</div>
        <div className="settings-card">
          {supportRows.map((t) => {
            const isHelp = t === 'Help center';
            return (
              <div
                className="settings-row"
                key={t}
                onClick={() => (isHelp ? navigate('/help') : soon(t))}
                role="button"
                tabIndex={0}
                data-testid={`pref-support-${t.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <div className="row-info"><div className="row-label">{t}</div></div>
                <span className="row-chevron">›</span>
              </div>
            );
          })}
        </div>

        <button
          className="btn-ghost"
          style={{ marginTop: 8 }}
          onClick={() => navigate(-1)}
          data-testid="preferences-back-btn"
        >
          ← Back
        </button>
      </div>

      {toast && <Toast msg={toast.msg} onDone={() => setToast(null)} />}
    </AppShell>
  );
}
